import Vue from 'vue'

import './cube-ui'
import App from './App.vue'
import router from './router-nsale'

// 引入Vant样式
import 'vant/lib/index.css'

import VueClipboard from 'vue-clipboard2'
import VueCanvasPoster from 'vue-canvas-poster'
import globalComponent from './components/index'

import sc from './utils/sc';
import touch from './utils/touch'
import store from './store'

import wxsdk from 'ny-wxsdk'

import './assets/style/variables.scss'


import Upload from './views/Nsale/personCenter/component/upload.vue'
Vue.component('Upload', Upload)


Vue.use(VueCanvasPoster)
Vue.use(VueClipboard)
Vue.config.productionTip = false

globalComponent()
window.router = router
window.toast = Vue.prototype.$createToast
window.$toast = function (txt) {
  window.toast({
    txt,
    type: 'txt'
  }).show()
}
Vue.prototype.$toast = window.$toast
Vue.prototype.$wx = wxsdk

router.beforeEach((to, from, next) => {
  const SCENE_KEY = 'scene'
  if (sessionStorage.getItem(SCENE_KEY)) {
    const sceneParams = {
      name: to.name,
      ...to.query
    }
    sessionStorage.setItem(SCENE_KEY, JSON.stringify(sceneParams))
  }
  // 设置主题色
  let websiteColor = to.query.websiteColor
  if(websiteColor) {
    localStorage.setItem('websiteColor', websiteColor)
  } else {
    websiteColor = localStorage.getItem('websiteColor') || 'ff7c6d'
  }
  store.commit('setWebsiteColor', websiteColor)
  // sc(to, from)
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
